import cn from "classnames";

import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import { brown } from "@/app/font";

import type { FreeQuoteDrawerDefaults } from "./freeQuoteDrawer.defaults";

export const FreeQuoteDrawerChrome = ({
  content,
  children,
}: FreeQuoteDrawerChromeProps) => (
  <div className="px-4 pt-24 pb-12 sm:px-6 sm:pt-28">
    <p
      className={cn(
        brown.className,
        "text-secondary-100 text-[16px] font-bold tracking-[0.08em] uppercase",
      )}>
      {content.callout}
    </p>
    <Text
      id="free-quote-drawer-title"
      component="h2"
      variant="h3"
      className="text-greyscale-headline mt-3 max-w-[680px] text-[32px]! leading-[1.12]!">
      {content.heading}
    </Text>

    <div className="text-greyscale-body mt-3 max-w-[760px] text-[16px] leading-[1.35]">
      <RichText children={content.intro} />
    </div>

    <p className="text-greyscale-body mt-6 mb-6 text-[12px]">
      {content.requiredFieldsMessage}
    </p>

    {children}
  </div>
);

type FreeQuoteDrawerChromeProps = {
  content: Pick<
    FreeQuoteDrawerDefaults,
    "heading" | "callout" | "intro" | "requiredFieldsMessage"
  >;
  children: React.ReactNode;
};
